module.exports = __webpack_public_path__ + "img/SinoTransPFS.1b8b7bc2.jpg";